import './SectionCard.scss';

import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

import Card from '../Card';

type SectionCardProps = {
  className: string;
  children: ReactNode;
};

const SectionCard = ({ children, className, ...otherProps }: SectionCardProps) => {
  const containerClasses = cn(
    'card--container_section tw-relative tw-rounded-[25px]',
    className,
    'tw-py-[20px] tw-px-[33px]'
  );

  return (
    <Card className={containerClasses} {...otherProps}>
      {children}
    </Card>
  );
};

export default SectionCard;
